import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUploadIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 84,
	height: 83,
	viewBox: "0 0 84 83",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M64.9353 71.4356c-.9392 0-1.7076-.7641-1.7076-1.6978v-7.4967c0-.9338.7684-1.6979 1.7076-1.6979h7.4499c.9392 0 1.7077.7641 1.7077 1.6979v7.4967c0 .9337-.7685 1.6978-1.7077 1.6978h-7.4499Z",
			fill: "#F4F8FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.1089 10.71h-33.666c-2.4048 0-4.3543 1.9495-4.3543 4.3543v33.7722c0 2.4048 1.9495 4.3542 4.3543 4.3542h33.666c2.4048 0 4.3542-1.9494 4.3542-4.3542V15.0643c0-2.4048-1.9494-4.3543-4.3542-4.3543Z",
			fill: "#9D9D9D"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M41.0445 25.5735c-.2002 0-.3622-.2555-.3622-.5712v-2.2846c0-.3151.162-.5706.3622-.5706h10.1408c.2002 0 .3622.2555.3622.5706v2.2846c0 .3157-.162.5712-.3622.5712H41.0445ZM66.9399 33.7428H41.5878c-.5005 0-.9055-.2554-.9055-.5711v-2.2846c0-.3152.405-.5706.9055-.5706h25.3521c.5005 0 .9055.2554.9055.5706v2.2846c0 .3157-.405.5711-.9055.5711ZM41.4067 41.9122c-.4004 0-.7244-.2555-.7244-.5711v-2.2846c0-.3152.324-.5707.7244-.5707h20.2817c.4003 0 .7244.2555.7244.5707v2.2846c0 .3156-.3241.5711-.7244.5711H41.4067Z",
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.9096 30.0442H16.2435c-2.4048 0-4.3542 1.9495-4.3542 4.3542v33.7723c0 2.4048 1.9494 4.3542 4.3542 4.3542h33.6661c2.4048 0 4.3542-1.9494 4.3542-4.3542V34.3984c0-2.4047-1.9494-4.3542-4.3542-4.3542Z",
			fill: "#DEDEDE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2435 30.0442h33.6661c2.4048 0 4.3542 1.9495 4.3542 4.3542v5.654H11.8893v-5.654c0-2.4047 1.9494-4.3542 4.3542-4.3542Z",
			fill: "#E1373B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.35 53.04C39.67 49.59 36.64 47 33 47c-2.89 0-5.4 1.64-6.65 4.04C23.34 51.36 21 53.91 21 57c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96ZM35 56v4h-4v-4h-3l5-5 5 5h-3Z",
			fill: "url(#paint0_linear_645_15051)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M67.7603 61.616v.7554h-6.4206v-.7554h-1.8464v1.8465h1.8464v-.7554h5.3238c-2.8424.8381-4.9647 3.3588-5.218 6.411-.4405.07-.7772.4516-.7772.9118a.9232.9232 0 1 0 1.1134-.9036c.2791-3.2518 2.7823-5.8673 5.9786-6.3135v.6497h1.8464v-.6626c3.2433.406 5.7953 3.0422 6.0765 6.3279-.4152.0903-.7261.4599-.7261.9021a.9233.9233 0 1 0 1.0621-.9129c-.2537-3.0517-2.3758-5.5719-5.2178-6.4099h5.3047v.7554h1.8465V61.616h-1.8465v.7554h-6.4994v-.7554h-1.8464Zm.3357.3357h1.175v1.175h-1.175v-1.175Zm-8.267 1.1751v-1.1751h1.175v1.1751h-1.175Zm16.6128-1.1751h1.175v1.1751h-1.175v-1.1751ZM61.004 70.0299c0-.3245.263-.5875.5875-.5875H61.6a.5876.5876 0 0 1-.0085 1.1751.5875.5875 0 0 1-.5875-.5876Zm14.8623-.5874.0072-.0001h.0068a.5875.5875 0 1 1-.014.0001Z",
			fill: "url(#paint1_linear_645_15051)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m73.4639 75.6496-4.721-9.442-4.721 9.442h9.442Z",
			fill: "url(#paint2_linear_645_15051)"
		}),
		/* @__PURE__ */ _jsx("g", {
			opacity: .3,
			fill: "#656565",
			children: /* @__PURE__ */ _jsx("path", { d: "M4.6847 9.1413c.7303.7303 1.9143.7303 2.6446 0 .7304-.7304.7304-1.9144.0001-2.6447-.7303-.7303-1.9144-.7303-2.6447 0-.7303.7303-.7303 1.9144 0 2.6447ZM20.4173 25.1268c.7303.7303 1.9143.7303 2.6446 0 .7303-.7303.7303-1.9144 0-2.6447-.7303-.7303-1.9143-.7303-2.6446 0-.7303.7303-.7303 1.9144 0 2.6447ZM9.9583 13.159c1.8846-1.8846 4.9402-1.8846 6.8248 0 1.8846 1.8846 1.8846 4.9402 0 6.8248-1.8847 1.8846-4.9402 1.8846-6.8248 0-1.8846-1.8846-1.8846-4.9401 0-6.8248ZM27.6639 14.2796c0 1.0328-.8372 1.87-1.87 1.87s-1.8701-.8372-1.8701-1.87.8373-1.87 1.8701-1.87 1.87.8372 1.87 1.87Z" })
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_645_15051",
				x1: 33,
				y1: 47,
				x2: 33,
				y2: 63,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#606060" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#373737"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_645_15051",
				x1: 68.7229,
				y1: 61.616,
				x2: 68.7229,
				y2: 75.6496,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF494E" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#E21E23"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_645_15051",
				x1: 68.7229,
				y1: 61.616,
				x2: 68.7229,
				y2: 75.6496,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF494E" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#E21E23"
				})]
			})
		] })
	]
});
export default SvgUploadIcon;
